<template>
  <div class="list row">
    <div class="col-md-8 mr-4">
      <div class="input-group mb-3">
        <input type="text" v-validate="'required|min:1|max:75'" class="form-control mr-2" placeholder="Search by name" v-model="name"/>
        <div class="input-group-append">
          <button class="btn btn-outline-secondary" type="button" @click="page = 1; retrieveStates();"><font-awesome-icon icon="search" /> Search</button>
        </div>
      </div>
    </div>
    <div class="col-md-3">
      <button class="btn btn-primary" @click="newState"><font-awesome-icon icon="plus" /> Add State</button>
    </div>
    <div class="col-md-12 hgap"></div>
    <div class="col-md-6">
      <h4><font-awesome-icon icon="list-alt" /> States List</h4>
      <ul class="list-group">
        <li class="list-group-item" :class="{ active: index == currentIndex }" v-for="(state, index) in states" :key="index"  @click="setActiveState(state, index)">
          {{ state.name }}
        </li>
      </ul>
      <div class="col-md-12 hgap"></div>
      <div v-if="loading" class="justify-content-center">
        <font-awesome-icon icon="spinner" /> <span>Loading...please wait</span>
      </div>
      <table class="table table-borderless">
        <tr>
          <td>
            <div class="d-flex justify-content-center">
              Items per Page:
              <select v-model="pageSize" @change="handlePageSizeChange($event)">
                <option v-for="size in pageSizes" :key="size" :value="size">
                  {{ size }}
                </option>
              </select>
            </div>
          </td>
          <td>
            <div class="d-flex justify-content-end">
              <b-pagination v-model="page" :total-rows="count" :per-page="pageSize" prev-text="Prev" next-text="Next" @change="handlePageChange"></b-pagination>
            </div>
          </td>
        </tr>
      </table>
    </div>
    <div class="col-md-6">
      <div v-if="currentState">
        <h4><font-awesome-icon icon="info-circle" /> State Details</h4>
        <table class="table">
        <tr>
          <td><strong>Code:</strong></td><td> {{ currentState.code }}</td>
        </tr>
        <tr>
          <td><strong>Name:</strong></td><td> {{ currentState.name }}</td>
        </tr>
        <tr>
          <td><strong>Country:</strong></td><td> {{ currentState.countryName }}</td>
        </tr>
        </table>

        <!-- <a class="m-3 btn btn-sm btn-warning" :href="'/states/' + currentState.id"><font-awesome-icon icon="edit" /> Edit </a>-->
        <router-link :to="{ path: '/states/' + currentState.id }" class="m-3 btn btn-sm btn-warning"><font-awesome-icon icon="edit" /> Edit </router-link>
      </div>
      <div v-else>
        <br />
        <p>Please click on a State...</p>
      </div>
    </div>
  </div>
</template>

<script>
import StateService from "../services/state.service";

export default {
  name: "states-list",
  data() {
    return {
      states: [],
      currentState: null,
      currentIndex: -1,
      name: "",

      page: 1,
      count: 0,
      pageSize: 5,
      pageSizes: [5, 10, 15, 20, 25],
      loading: false
    };
  },
  methods: {
    /*retrieveStates() {
      StateService.getAll()
        .then(response => {
          this.states = response.data;
          //console.log(response.data);
        })
        .catch(e => {
          console.log(e);
        });
    },*/

    retrieveStates() {
      this.loading = true;
      if (this.page) {
        this.page = this.page - 1;
      }
      StateService.getAllPageable(this.name, this.page, this.pageSize)
        .then(response => {
          const { states, totalItems } = response.data;
          this.states = states;
          this.count = totalItems;
          this.loading = false;
          //console.log(response.data);
        })
        .catch(e => {
          console.log(e);
        });
    },

    handlePageChange(value) {
      this.page = value;
      this.retrieveStates();
    },

    handlePageSizeChange(event) {
      this.pageSize = event.target.value;
      this.page = 1;
      this.retrieveStates();
    },

    refreshList() {
      this.retrieveStates();
      this.currentState = null;
      this.currentIndex = -1;
    },

    setActiveState(state, index) {
      this.currentState = state;
      this.currentIndex = index;
    },

    removeAllStates() {
      StateService.deleteAll()
        .then(response => {
          console.log(response.data);
          this.refreshList();
        })
        .catch(e => {
          console.log(e);
        });
    },
    
    /*searchName() {
      StateService.getByName(this.name)
        .then(response => {
          this.states = response.data;
          //console.log(response.data);
        })
        .catch(e => {
          console.log(e);
        });
    },*/

    newState() {
      this.$router.push('/addstate');
    }
  },
  mounted() {
    this.retrieveStates();
  }
};
</script>

<style>
.list {
  text-align: left;
  max-width: 100%;
  margin: auto;
  margin-top: 3.2em;
}
.paginate{
  margin-top: 1.7em;
}
.hgap{
  clear: both;
  margin-top: 1.1em;
}
</style>